var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('List'),_c('v-row',{staticClass:"my-5",attrs:{"wrap":""}},[_c('v-col',{attrs:{"cols":"12","md":"6","lg":"4"}},[_c('Domains',{staticClass:"mb-3"}),_c('DeleteMany')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }